<!--
 * @Author: 王耀民
 * @Date: 2022/3/22 9:39
 * @Description: 工程业绩详情弹窗
-->
<template>
  <div>
    <el-dialog
      :visible="visible"
      :before-close="close"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="工程业绩"
      class="performance-detail-modal"
    >
      <el-row>
        <el-col class="detail-title">
          工程业绩详情
        </el-col>
        <el-col :span="24" class="detail-item" v-if="detailData.teamName">
          <span class="item-name">所属工队：</span>
          <span class="item-value">{{ detailData.teamName }}</span>
        </el-col>
        <el-col :span="12" class="detail-item" v-if="detailData.projectName">
          <span class="item-name">项目名称：</span>
          <span class="item-value">{{ detailData.projectName }}</span>
        </el-col>
        <el-col :span="12" class="detail-item" v-if="detailData.owner">
          <span class="item-name">业主单位：</span>
          <span class="item-value">{{ detailData.owner }}</span>
        </el-col>
        <el-col :span="12" class="detail-item" v-if="detailData.address">
          <span class="item-name">施工地点：</span>
          <span class="item-value">{{ detailData.address + detailData.projectPlace }}</span>
        </el-col>
        <el-col :span="12" class="detail-item" v-if="detailData.startTime">
          <span class="item-name">施工/竣工时间：</span>
          <span class="item-value">{{  `${formatTime(detailData.startTime)}~${detailData.endTime==0?"正在建设":formatTime(detailData.endTime)}`  }}</span>
        </el-col>

        <el-col :span="24" class="detail-item" v-if="detailData.projectDescribe">
          <span class="item-name">项目描述：</span>
          <span class="item-value">{{ detailData.projectDescribe }}</span>
        </el-col>
        <el-col :span="24" class="detail-item" v-if="detailData.construction">
          <span class="item-name">施工内容：</span>
          <span class="item-value">{{ detailData.construction }}</span>
        </el-col>

        <el-col :span="24" class="detail-item" v-if="detailData.images && detailData.images.length">
          <span class="item-name">图片：</span>
          <span class="item-value">
          <el-image
            :z-index="99999"
            v-for="(url,index) in detailData.images"
            :key="index"
            fit="cover"
            style="width: 100px; height: 100px;margin-right: 20px;object-fit: cover;flex:1"
            :src="url"
            :preview-src-list="[url]">
          </el-image>
        </span>
        </el-col>
        <el-col :span="24" class="detail-item" v-if="detailData.video">
          <span class="item-name">视频：</span>
          <span class="item-value">
          <span class="item-video" @click="$refs.videoPreview.open(detailData.video)">
            <video style="object-fit: cover" :src="detailData.video"></video>
          </span>
        </span>
        </el-col>
        <template v-if="detailData.customFieldList && detailData.customFieldList.length">
          <el-col :span="24" class="detail-item" v-for="(field,index) in detailData.customFieldList" :key="index">
          <span class="item-name">{{ field.title }}：</span>
          <span class="item-value">{{ field.value }}</span>
          </el-col>
        </template>
        <el-col :span="24" class="detail-item" v-if="detailData.fileList && detailData.fileList.length">
          <span class="item-name">附件：</span>
          <span style="display: flex; flex-wrap: wrap">
            <div
              v-for="(file, index) in detailData.fileList"
              :key="index"
              class="file-item"
            >
              <div class="file-item-container">
                <img
                  :src="fileIcon[file.name.split('.').pop().toLowerCase()]"
                  alt=""
                  class="file-icon"
                />
                <div class="file-info">
                  <div class="file-name">
                    <div class="fore">
                      {{
                        file.name.slice(0, file.name.lastIndexOf("."))
                      }}
                    </div>
                    <div class="back">
                      .{{ file.name.split(".").pop() }}
                    </div>
                  </div>
                  <div class="file-other">
                    <span class="file-size">{{
                      formatFileSize(file.size)
                    }}</span>
                    <span
                      class="file-download"
                      @click="$previewFile(file.fileUrl)"
                      >预览</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </span>
        </el-col>
      </el-row>
      <el-row v-if="detailData.mainBusiness || detailData.businessDescription|| (detailData.businessFieldList && detailData.businessFieldList.length)">
        <el-col class="detail-title" style="margin-top: 20px;">
          隶属单位业务
        </el-col>
        <el-col :span="24" class="detail-item" v-if="detailData.mainBusiness">
          <span class="item-name">主营业务：</span>
          <span class="item-value">{{ detailData.mainBusiness }}</span>
        </el-col>
        <el-col :span="24" class="detail-item" v-if="detailData.businessDescription">
          <span class="item-name">业务描述：</span>
          <span class="item-value">{{ detailData.businessDescription }}</span>
        </el-col>
        <template v-if="detailData.businessFieldList && detailData.businessFieldList.length">
          <el-col :span="24" class="detail-item" v-for="(field,index) in detailData.businessFieldList" :key="index">
          <span class="item-name">{{ field.name }}：</span>
          <span class="item-value">{{ field.content }}</span>
          </el-col>
        </template>
      </el-row>
    </el-dialog>
    <VideoPreview ref="videoPreview"/>
  </div>
</template>

<script>
import {apiTeamDetail} from '@/api/apiTeamDetail'
import moment from 'moment'
import "@/utils/previewFile"

export default {
  name: "PerformanceDetailsModal",
  data() {
    return {
      visible: false,
      detailData: {},
      fileIcon: {
        jpg: require("@/assets/fileIcon/image.png"),
        jpeg: require("@/assets/fileIcon/image.png"),
        png: require("@/assets/fileIcon/image.png"),
        pdf: require("@/assets/fileIcon/pdf.png"),
        zip: require("@/assets/fileIcon/zip.png"),
        rar: require("@/assets/fileIcon/zip.png"),
        doc: require("@/assets/fileIcon/word.png"),
        docx: require("@/assets/fileIcon/word.png"),
        xlsx: require("@/assets/fileIcon/xls.png"),
        xls: require("@/assets/fileIcon/xls.png")
      }
    }
  },
  components: {
    VideoPreview: () => import('./components/VideoPreview'), // 视频放大预览弹窗
  },
  methods: {
    /**
     * 打开工程业绩详情弹窗
     * @param no 工程业绩no
     */
    async open(no) {
      this.visible = true
      const res = await apiTeamDetail.getPerformanceDetail(no)
      if (res.data.code == 200) {
        this.detailData = res.data.data
        if(this.detailData.images){
          this.detailData.images = this.detailData.images.split(',')
        }
      } else {
        this.$message.error(`系统异常，请稍后再试`)
      }
    },
    // 关闭工程业绩弹窗
    close() {
      this.visible = false
      this.detailData = {}
    },
     /**
     * 格式化页面显示的文件大小
     * @param fileSize 文件大小
     */
    formatFileSize(fileSize = 0) {
      fileSize = Number(fileSize)
      if (fileSize /1024 > 10) {
        return `${(fileSize /1024).toFixed(2)}M`
      } else {
        return `${Math.ceil(fileSize)}kb`
      }
    },
    /**
     * 格式化时间
     * @param time 原时间信息
     * @param format 格式，默认YYYY-MM-DD
     */
    formatTime(time, format = 'YYYY-MM-DD') {
      return moment(time).format(format)
    }
  }
}
</script>

<style lang="scss" scoped>
.performance-detail-modal {
  /deep/.el-dialog__title{
    line-height: 1;
  }
  /deep/ .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid var(--FCe);
  }
  /deep/.el-dialog__body{
    padding: 30px 20px 20px !important;
    border-top: none !important;
  }

  .detail-title {
    margin-bottom: 10px;
    position: relative;
    padding: 0 0 10px 13px;
    font-size: 18px;
    color: var(--Cfs2);
    border-bottom: 1px dashed #e5e5e5;

    &:before {
      content: '';
      position: absolute;
      top: 2px;
      left: 0;
      width: 3px;
      height: 20px;
      background: var(--Cfs3);
    }
  }

  .detail-item {
    display: flex;
    padding: 10px 0;
    &:last-of-type{
      padding-bottom: 0;
    }
    .item-name {
      flex-shrink: 0;
      color: var(--FC6);
    }
    .file-item {
      .file-item-container {
        box-sizing: border-box;
        width: 236px;
        display: flex;
        padding: 10px 20px 10px 10px;
        margin:0px 10px 10px 0px ;
        background-color: #fafafa;
        font-size: 14px;
        border-radius: 4px;
        .file-icon {
          width: 33px;
          height: 40px;
        }
        .file-info {
          flex: 1;
          padding-left: 10px;
          line-height: 1.2;
          .file-name {
            margin-bottom: 10px;
            display: flex;
            color: var(--FC3);
            .fore {
              max-width: 148px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
            }
            .back {
              flex-shrink: 0;
            }
          }
          .file-other {
            display: flex;
            justify-content: space-between;
            .file-size {
              color: var(--FC9);
            }
            .file-download {
              cursor: pointer;
              color: #0286df;
            }
          }
        }
      }
    }
    .item-value {
      color: var(--FC3);
      .item-video {
        position: relative;
        display: inline-block;
        width: 150px;
        height: 100px;
        cursor: pointer;
        > video {
          width: 100%;
          height: 100%;
        }
        &:before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(calc(-50% + 10px), -50%);
          border: solid;
          border-width: 10px 15px;
          border-color: transparent transparent transparent #fff;
        }
      }
    }
  }
}
</style>

